import { Button, Rating, Typography } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useState } from "react";
import { EnquiryTopBanner } from "../components/EnquiryTopBanner";
import { enquiryOperationsList } from "../constants/enquiry.constants";
import dayjs from "configs/dayjs.config";

import { useEnquiryContext } from "../context";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { POCDetailsRowForUpdate } from "../components/POCDetailsRowForUpdate";
import { updateEnquiryApi } from "API/apis/enquiry/updateEnquiry";
import { PROJECT_CLIENT_TYPE_LIST } from "constants/projectClient.constants";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { SingleSelect } from "components/Select/SingleSelect";
import { CURRENCY } from "constants/currencyConstants";

const initialState = {
  id: 0,
  companyId: 0,
  clientName: "",
  clientType: "",
  weightage: 0,
  deliveryDate: new Date(),
  targetConversionDate: new Date(),
  budget: 0,
  clientAddress: "",
  link: "",
  clientContactNo: "",
  clientEmail: "",
  pocList: [
    {
      pocName: "",
      pocDesignation: "",
      pocContact: "",
      pocContactOther: "",
      pocContactOther2: "",
      pocEmail: "",
      pocEmailOther: "",
      pocEmailOther2: "",
    },
  ],
};
export const UpdateEnquiry = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { setCurrentOperationPage, previewEnquiry, setReloadRequired } =
    useEnquiryContext();
  const [formData, setFormData] = useState(previewEnquiry);

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleWeightageChange = (newValue) => {
    setFormData({
      ...formData,
      weightage: newValue,
    });
  };
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deliveryDate: newValue.toDate(),
      });
    }
  };
  const handleTargetConversionDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        targetConversionDate: newValue.toDate(),
      });
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const { data, status } = await updateEnquiryApi({ ...formData });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setReloadRequired(true);
      setSuccess(data?.message);
      setCurrentOperationPage(enquiryOperationsList.listEnquiry);
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle pageName={pageName.enquiry.updateEnquiry} />
      <EnquiryTopBanner
        buttonType="back"
        enquiryOperationsParam={enquiryOperationsList.listEnquiry}
      />
      <form onSubmit={handleUpdateUserSubmit}>
        <TextFieldWrapper
          id="clientName"
          name="clientName"
          label="Name"
          variant="outlined"
          value={formData.clientName}
          fullWidth
          required
          onChange={handleChange}
        />
        <SingleSelect
          label="Type*"
          name="clientType"
          handleSelectSingle={handleSelectChange}
          options={PROJECT_CLIENT_TYPE_LIST}
          selectedOption={formData.clientType}
        />
        <TextFieldWrapper
          id="clientContactNo"
          name="clientContactNo"
          label="Contact Number"
          variant="outlined"
          value={formData.clientContactNo}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="clientEmail"
          name="clientEmail"
          type="email"
          label="Email"
          variant="outlined"
          value={formData.clientEmail}
          fullWidth
          required
          onChange={handleChange}
        />
        <Typography component="legend">Weightage</Typography>
        <Rating
          name="weightage"
          value={formData.weightage}
          onChange={(e, newValue) => handleWeightageChange(Number(newValue))}
          size="large"
        />
        <DatePickerWrapper
          label="Delivery Date"
          value={dayjs(formData.deliveryDate)}
          onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
        />
        <DatePickerWrapper
          label="Target Conversion Date"
          value={dayjs(formData.targetConversionDate)}
          onChange={(newValue) =>
            handleTargetConversionDateChange(dayjs(newValue))
          }
        />
        <TextFieldWrapper
          id="budget"
          name="budget"
          label="Budget"
          type="number"
          variant="outlined"
          value={formData.budget}
          fullWidth
          required
          onChange={handleChange}
        />
        <SingleSelect
          label="Currency"
          name="currency"
          handleSelectSingle={handleSelectChange}
          options={CURRENCY}
          selectedOption={formData.currency}
        />
        <TextFieldWrapper
          id="clientAddress"
          name="clientAddress"
          label="Client-Address"
          variant="outlined"
          value={formData.clientAddress}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="clientCity"
          name="clientCity"
          label="Client-City"
          variant="outlined"
          value={formData.clientCity}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="link"
          name="link"
          label="Link"
          variant="outlined"
          value={formData.link}
          fullWidth
          onChange={handleChange}
        />
        <POCDetailsRowForUpdate formData={formData} setFormData={setFormData} />
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
